'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = setCookie;

var _universalCookie = require('universal-cookie');

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECONDS_IN_DAY = 24 * 60 * 60 * 1000;

function setCookie(cname, cvalue) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  var exdays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 365;

  if (isBrowser) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * SECONDS_IN_DAY);
    var expires = d;

    var cookie = new _universalCookie2.default().set(cname, cvalue, {
      path: path,
      expires: expires,
      secure: true,
      httpOnly: true
    });

    document.cookie = cookie;
  }
}